import React, { useState } from "react";
import useLoading from "./hooks/useLoading";
import useDomainValidation from "./hooks/useDomainValidation";
import FilterButton from "./components/FilterButton";
import ImagesContainer from "./components/ImagesContainer";
import LoadingSpinner from "./components/LoadingSpinner";
import HeroSection from "./components/HeroSection";
import beforeAfterImages from "./components/Data/data";
import "./App.css";

function App() {
  const isLoading = useLoading(); // Custom hook for loading state
  const allowedDomains = process.env.REACT_APP_ALLOWED_DOMAINS.split(",");
  const isAllowedDomain = useDomainValidation(allowedDomains); // Custom hook for domain validation

  const [selectedCategory, setSelectedCategory] = useState("All");

  // Render loading spinner while loading
  if (isLoading) {
    return <LoadingSpinner />;
  }

  // Render components only if the domain is allowed
  if (!isAllowedDomain) {
    return <div><h2 className="not-allowed">Domain not allowed</h2></div>;
  }

  // Retrieve the correct domain from environment variable
  const localURL = process.env.REACT_APP_LOCAL_URL;
  const prodURL = process.env.REACT_APP_PROD_URL;

  // Determine which URL to use based on the environment
  const baseURL = process.env.NODE_ENV === 'development' ? localURL : prodURL;

  // Function to handle category selection
  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

   // Filter images based on selected category
  const filteredImages =
    selectedCategory === "All"
      ? beforeAfterImages
      : beforeAfterImages.filter((image) => image.category === selectedCategory);

  return (
    <div className="App">
      <HeroSection baseURL={baseURL} />
      <div className="filter">
        {["All", 
        "Interior Painting", 
        "Exterior Painting", 
        "Commercial Painting", 
        "Deck Services"].map(
          (category, index) => (
            <FilterButton
              key={index}
              category={category}
              isSelected={selectedCategory === category}
              onClick={handleCategorySelect}
            />
          )
        )}
      </div>
    <ImagesContainer baseURL={baseURL} filteredImages={filteredImages} />
    </div>
  );
}

export default App;
